import { lowerCase } from 'lodash';

const DRAFT = 'draft';
export const VALID_BULK_ACTION_STATES = [
  DRAFT,
];

export function isValidForBulkSelect(window) {
  const urlParams = new URLSearchParams(window.location.search);
  return VALID_BULK_ACTION_STATES.includes(lowerCase(urlParams.get('state')));
}
